<template>
    <div ref="featureCard" class="feature-card">
        <div data-name="feature-card-content">
            <div data-name="feature-card-header" class="position-relative">
                <div v-if="campaign.crosspromoter" class="badge">
                        <Icon v-b-tooltip.hover title="Active Crosspromoter" icon="badge"  class="active-cp-badge"/>
                    </div>
                <div @click="toCampaignPage(campaign.id)" data-name="overlay">
                    <p>View More</p>
                </div>
                <div 
                    v-if="!isAnouncement"
                    :class="[campaign.author_id === user.uid ? 'justify-content-end': 'justify-content-between']"
                    class="position-absolute d-flex flex-column h-100 card-header-icon">
                        <Favorite 
                            :favorite-location = "cardType"
                            :card-data="campaign" 
                            class="heart-icon"
                            style="margin-left: 12px; margin-top: 12px; z-index: 1000"/>
                        <a 
                            :href="campaign.project_url" 
                            target="_blank" 
                            style="z-index: 1000" 
                            @click="toProject"
                            class="ks-link">
                            <Icon icon="kickstarter" />
                        </a>
                </div>
                <img
                    :src = "campaign.thumbnails && campaign.thumbnails['medium'] || campaign.image"
                    :alt=" `${cardType} thumbnail`"
                    :class="{'announcement-thumbnail': isAnouncement}"
                    class="f-card-thumbnail" />
            </div>
            <div data-name="feature-card-body" :class="{'flex-column-reverse': isAnouncement}">
                <div 
                    :class="{
                         'justify-content-between': hasStatus || isAnouncement,
                         'justify-content-end': !hasStatus,
                         'flex-column': !isAnouncement,
                         'w-100 mt-3 align-items-end': isAnouncement
                    }"
                    data-name="card-body-section-first" 
                    class="d-flex">
                        <div v-if="hasStatus" data-name="status">
                            <div class="d-flex align-items-center ">
                                <Icon :icon="campaign.indemand ? 'in-demand-status' : 'live-status'"/> 
                                <p class="text-capitalize">{{ campaign.indemand ? 'InDemand': campaign.state}}</p>
                            </div>
                        </div>
                        <div data-name="backers" v-if="!isAnouncement">
                            <p>Backers</p>
                            <p>{{campaign.backers}}</p>
                        </div>
                        <div data-name="backers" v-else>
                            <p></p>
                            <p>{{campaign.eventDate}}</p>
                        </div>
                        <CpButton 
                            v-if = "isAnouncement"
                            :campaign="campaign" 
                            :button-location = "cardType"
                        />
                </div>
                <div data-name="card-body-section-second" :class="{'p-0 pl-1': isAnouncement}">
                    <div data-name="title-desc" class="line-clamp">
                        <p>{{ campaign.title }}</p>
                        <p>{{ campaign.description }}</p>
                    </div>
                    <CpButton 
                        v-if = "!isAnouncement"
                        :campaign="campaign" 
                        :button-location = "cardType"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CpButton from '../CpButton'
import { Favorite } from '../Icons'
import Icon from "../Theme/Icon";
import Thumbnail from "../Theme/Thumbnail"
export default {
    name: 'Card',
    components: {
        Icon,
        Favorite,
        CpButton,
        Thumbnail
    },
    props: ['campaign', 'type'],
    computed: {
        ...mapState([
            'user'
        ]),
        hasStatus(){
            return this.campaign.state && this.campaign.state !== 'ended' || this.campaign.indemand
        },
        cardType(){
            return this.type === 'featured' ? 'Featured Campaign' : 'Recommendations'
        },
        isAnouncement(){
            return this.campaign.type === 'announcement'
        }
    },
    methods: {
        toProject: function(){
            this.$ga.event('Campaign', 'KS Icon Click', `
                Location: ${this.cardType},
                Campaign: ${this.campaign.title}
            `)

            this.$sendMixpanelEvent('KS Icon Clicked', {
                'KS Icon Location': this.cardType,
                'Viewed Campaign': this.campaign.title
            });
        },
        toCampaignPage: function(id) {
            if(this.isAnouncement) {
                this.$ga.event('Announcement', 'Webinar Link Clicked');
                this.$sendMixpanelEvent('Webinar Link Clicked');
                window.open(this.campaign.url, '_blank').focus();
                return
            }
            this.$ga.event('Campaign', 'View More Click', `
                Location: ${this.cardType},
                Campaign: ${this.campaign.title}
            `);
            this.$sendMixpanelEvent('Campaign View More Clicked', {
                'Campaign Card Location': this.cardType,
                'Viewed Campaign Name': this.campaign.title
            });
            this.$router.push({path: `/campaigns/${id}`}).catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
div.feature-card {
    width: 100%;
    background: #FFFFFF;

    div[data-name="feature-card-content"] {

        div[data-name="feature-card-header"] {
            height: 240px;
            div.badge {
                position: absolute;
                z-index: 100;
                top: 8px;
                right: 8px;
                transform: scale(1.2);
                transition: all 0.2s ease;
                &:hover {
                    transform: scale(1.3);
                }
            }
            .f-card-thumbnail {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 3px;
                &.announcement-thumbnail {
                    object-position: left;
                }
            }
            div[data-name="overlay"] {
                display: none;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: none;
                transition: all 0.2s ease;
                z-index: 99;
                p {
                    display: none;
                    cursor: pointer;
                }
            }
            div.card-header-icon{
                width: 30px;
            }

            &:hover {
                div[data-name="overlay"] {
                    display: flex;
                    background: #00000080;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    border-radius: 3px;
                    p {
                        display: block;
                        font-size: $p2;
                        color: $c14;
                        font-weight: $weight_bold;  
                    }
                }
            }
        }
        div[data-name="feature-card-body"] {
            height: 171px;
            display: flex;
            margin-top: 16px;
            div[data-name="card-body-section-first"] {
                width: 97px;
                height: 100%;
                div[data-name="status"] {
                    p {
                        margin-bottom: 0;
                        margin-left: 7px;
                        color: $c6o8;
                        font-size: $p5;
                    }
                }
                div[data-name="backers"] {
                    background: #F4F4F4;
                    border-radius: 3px;
                    width: 97px;
                    flex-shrink: 0;
                    text-align: center !important;
                    p {
                        color: $c6o7;
                        font-size: $p2;
                        font-weight: $weight_bold;
                        margin-bottom: 12px;
                    
                        &:first-child {
                            margin-top: 12px;
                            margin-bottom: 0 !important;
                            color: $c7o8;
                            font-size: $p5;
                            font-weight: normal !important;
                        }
                    }
                }
            }
            div[data-name="card-body-section-second" ] {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding-left: 23px;
                padding-right: 12px;
                flex-grow: 1;
                div[data-name="title-desc"] {
                    overflow: hidden;
                    text-overflow:ellipsis;
                    &.line-clamp {
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;  
                    }
                    p {
                        &:first-child {
                            color: $c6;
                            font-size: $p2;
                            font-weight: $weight_bold;
                            line-height: 23px;
                            margin-bottom: 10px;
                        }
                        color: $c7;
                        font-size: $p4;
                        margin: 0;

                    }
                }
            }
        }
    }
}


</style>